module.exports = __webpack_public_path__ + "assets/img/2201591934007_.pic_hd.3cbf3ae9.jpg";